import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>GiveLive</h3>
          <p>
            Nền tảng tổ chức Giveaway chuyên nghiệp dành cho streamer và người sáng tạo nội dung.
            Tạo những khoảnh khắc tương tác đáng nhớ cùng người xem của bạn.
          </p>
        </div>
        
        <div className="footer-section">
          <h4>Hệ Sinh Thái</h4>
          <ul>
            <li><a href="https://sekaiz.net" target="_blank" rel="noopener noreferrer">SekaiZ - Giải pháp Marketing</a></li>
            <li><a href="https://mezlang.sekaiz.net" target="_blank" rel="noopener noreferrer">Mezlang - Extension học ngoại ngữ</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Liên Hệ</h4>
          <ul className="contact-info">
            <li>
              <i className="fas fa-envelope"></i>
              <span><a href="mailto:givelive@sekaiz.net">givelive@sekaiz.net</a></span>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; 2024 GiveLive all rights reserved by <a href="https://sekaiz.net" target="_blank" rel="noopener noreferrer">SekaiZ</a></p>
          <div className="footer-bottom-links">
            <Link to="/terms">Điều khoản sử dụng</Link>
            <Link to="/privacy">Chính sách bảo mật</Link>
            <Link to="/cookies">Chính sách cookie</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
